// +----------------------------------------------------------------------
// | 大屏尺寸响应
// +----------------------------------------------------------------------

export function windowAuto(vm) {
  const windowWidth = window.innerWidth / 1920;
  const windowHeight = window.innerHeight / 1080;
  if (windowWidth > windowHeight) {
    vm.autoWidows = windowHeight;
  } else {
    vm.autoWidows = windowWidth;
  }
  const top = (window.innerHeight - 1080 * vm.autoWidows) / 2;
  vm.top = top;
  const left = (window.innerWidth - 1920 * vm.autoWidows) / 2;
  vm.left = left;
}
 
export function addResizeListener(vm) {
  window.addEventListener("resize", () => windowAuto(vm));
}

export function removeResizeListener(vm) {
  window.removeEventListener("resize", () => windowAuto(vm));
}